var installedModules = {};
var moduleToHandlerMapping = {
	7082: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	4542: {
		getter: () => (Promise.all([__webpack_require__.e(519), __webpack_require__.e(97), __webpack_require__.e(269), __webpack_require__.e(972)]).then(() => (() => (__webpack_require__(5097))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.52",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@bwoty-web/ui-kit",
	},
	1967: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.14 || 15 || 16 || 17 || 18",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	4556: {
		getter: () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(604)]).then(() => (() => (__webpack_require__(3935))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	5098: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	5269: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": ">= 16.8.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	1126: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.0.0 || ^17.0.0 || ^18.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	7582: {
		getter: () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(604)]).then(() => (() => (__webpack_require__(3935))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.0.0 || ^17.0.0 || ^18.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	8437: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	2604: {
		getter: () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(7294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"82": [
		7082
	],
	"228": [
		1967,
		4556,
		5098
	],
	"269": [
		5269
	],
	"542": [
		4542
	],
	"604": [
		2604
	],
	"972": [
		1126,
		7582,
		8437
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}